<template>
  <div class="p-t-10">
    <van-form @submit="onSubmit">
      <van-field v-model="code_sn" name="code_sn"  ref="codeEle" label="二维码" autofocus autocomplete="off" placeholder="请输入二维码" required :rules="[{ required: true, message: '请输入二维码' }]" label-class='tw-flex tw-items-center'>
        <!-- <template #button>
          <van-button color='#5B9DFF' type="primary" size="small" native-type="submit">解除</van-button>
        </template> -->
      </van-field>
          <div class=" tw-left-0 tw-bottom-0 s_flex_center width100 p-15 m-t-80" >
      <van-button block round color="linear-gradient(to right, #53A1FF, #68D0FF)" @click='onSubmit'>确定解除</van-button>
    </div>
    </van-form>
    <p class="m-t-10 p-15 s_bf fz-14" v-if='msg'>结果：{{msg}}</p>
  </div>
</template>
<script>
import { normalizeQrCode } from '@/utils/qrCode';
import { ref, reactive, toRefs } from "@vue/reactivity";
import { Toast,Dialog } from 'vant';
import { iscode } from '@/utils/app.js';
import { codeDissolve } from '@/api/inWarehouse.js';
import { useNfc } from '@/hooks/useNfc'
export default {
  setup(props) {
    const state = reactive({
      code_sn: '',
      msg:''
    })
    const codeEle=ref('')
    const onSubmit = async() =>{
      state.code_sn = normalizeQrCode(state.code_sn);
      Dialog.confirm({
        title: '确定解除码关系？',
        confirmButtonColor:'#5B9DFF',
      }).then(async() => {

        codeEle.value.blur()
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        });
        let result = await codeDissolve({code_sn:state.code_sn}).then(res => res.data).catch(error => error)
        Toast.clear();
        if (iscode(result)) {
          state.msg = '解除成功'
        } else {
          state.msg = result.msg
          Toast.fail(result.msg);
        }
        codeEle.value.focus()
      }).catch(() => {})
    }
    // ===== NFC 接入：原生读到标签后自动回调，params 即码内容 =====
    useNfc((params) => {
      state.code_sn = params
      onSubmit()
    })
    // ===== NFC 接入结束 =====
    return{
      ...toRefs(state),
      onSubmit,
      codeEle
    }
  }
}
</script>
